import { createInsuranceProductPreset } from '../common/productPresetFactory'

const COPY_BY_PRESET = {
  default: {
    heroTitle: '생활 위험별 보장 우선순위를 기준으로 종합보험을 점검합니다',
    heroSubtitle: '질병·상해·배상 등 여러 담보를 현재 생활 단계에 맞춰 정리합니다.',
    formTitle: '종합보험 상담 신청',
  },
  'clean-form': {
    heroTitle: '종합보험의 담보 구성과 유지 가능성을 함께 확인합니다',
    heroSubtitle: '많은 특약 중 실제 필요한 보장과 조정 가능한 보장을 구분합니다.',
    formTitle: '보장 구성 상담',
  },
  'hanwha-sections': {
    heroTitle: '가족 상황에 맞는 종합보험 포인트를 한 번에 정리해드립니다',
    heroSubtitle: '가족 상황에 맞춰 꼭 필요한 보장과 줄여도 되는 부분을 한 번에 안내해드립니다.',
    formTitle: '맞춤 종합보험 신청',
  },
  'basic-template-4': {
    heroTitle: '복잡한 특약보다 지금 필요한 보장부터 확인하세요',
    heroSubtitle: '우선순위가 높은 보장부터 확인하고 현재 상황에 맞는 상담 방향을 정리합니다.',
    formTitle: '우선순위 점검 요청',
  },
  'basic-template-5': {
    heroTitle: '과한 보장은 줄이고 핵심은 남기는 종합보험 가이드',
    heroSubtitle: '가족 보장, 생활 리스크, 유지 가능성까지 균형 있게 정리해드립니다.',
    formTitle: '전문 상담 요청',
  },
}

export function getProductComprehensivePreset(presetKey = 'default') {
  const copy =
    COPY_BY_PRESET[presetKey]
    || (presetKey === 'lead-gen-fullbleed' ? COPY_BY_PRESET['hanwha-sections'] : undefined)
    || COPY_BY_PRESET.default
  return createInsuranceProductPreset('PRODUCT_COMPREHENSIVE', copy, presetKey)
}
